export default function FormMetaField({ field, updateField, removeField }) {
  return (
    <div className="border p-3 rounded-lg space-y-2">
      <input
        type="text"
        placeholder="Tên trường (meta_name)"
        value={field.meta_name}
        onChange={(e) => updateField(field.id, { meta_name: e.target.value })}
        className="border rounded p-2 w-full"
      />

      <input
        type="text"
        placeholder="Alias (meta_alias)"
        value={field.meta_alias}
        onChange={(e) => updateField(field.id, { meta_alias: e.target.value })}
        className="border rounded p-2 w-full"
      />

      <select
        value={field.meta_type}
        onChange={(e) => updateField(field.id, { meta_type: e.target.value })}
        className="border rounded p-2 w-full"
      >
        <option value="text">Text</option>
        <option value="textarea">Textarea</option>
        <option value="select">Select</option>
        <option value="radio">Radio</option>
        <option value="checkbox">Checkbox</option>
        <option value="textbox_multi">Textbox Multi</option>
      </select>

      <textarea
        placeholder='Meta Value (JSON options nếu cần)'
        value={field.meta_value}
        onChange={(e) => updateField(field.id, { meta_value: e.target.value })}
        className="border rounded p-2 w-full"
      />

      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={field.required === 1}
          onChange={(e) => updateField(field.id, { required: e.target.checked ? 1 : 0 })}
        />
        Bắt buộc
      </label>

      <button
        onClick={() => removeField(field.id)}
        className="bg-red-500 text-white px-3 py-1 rounded-lg"
      >
        Xóa
      </button>
    </div>
  );
}
